const ProtectorGlass = () => {
    return <div className="absolute inset-0 z-40 bg-white opacity-60 cursor-not-allowed border-0"></div>
}

export default ProtectorGlass
